import { render, staticRenderFns } from "./personnelAnalysisWx.vue?vue&type=template&id=681f1744&scoped=true&"
import script from "./personnelAnalysisWx.vue?vue&type=script&lang=js&"
export * from "./personnelAnalysisWx.vue?vue&type=script&lang=js&"
import style0 from "./personnelAnalysisWx.vue?vue&type=style&index=0&id=681f1744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f1744",
  null
  
)

export default component.exports